import DetailsView from "./view";
import { useSelector } from "react-redux";
import { ReducersTypes } from "../../redux/reducers/Models";
import { PropsView } from "../home/Models";
import useRedirect from "../../hooks/useRedirect";
import { useNavigate, useParams } from "react-router-dom";

export default function Details() {
  useRedirect("details");
  
  const navigate = useNavigate();

  const { id } = useParams();

  const user = useSelector((state: ReducersTypes & {
    userReducer: ReducersTypes['userReducer'] & {
      debts: PropsView['items'];
    }
  }) => state.userReducer);

  const getGroupedDebts = () => {
    return user?.debts?.groupedDebts?.find(item => item.owner === id);
  }
  
  const goBack = () => navigate(-1);
  
  return (
    <DetailsView 
      groupedDebts={getGroupedDebts()}
      goBack={goBack}
    />
  );
}
